







import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "../fixedPhrase/FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "../fixedPhrase/mixins";
import { IEditFixedPhrase } from "../fixedPhrase/IEditFixedPhrase";
import { FixedPhraseKinds } from "../fixedPhrase/FixedPhraseKinds";
import { AiFixedPhraseSelectorMixin } from "./mixins";
import { AiSyntaxDialog } from "./dialogs";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
    AiSyntaxDialog,
  }
})
export default class AiUserFixedPhraseSelector extends Mixins(
  AiFixedPhraseSelectorMixin,
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  userId: string;

  @Prop({ default: true })
  isPastable: boolean;

  async created(): Promise<void> {
    try {
      const fixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.AiUser, this.userId);
      this.rootFixedPhrase = fixedPhrase;
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "個人生成AI定型文取得失敗",
        "個人生成AI定型文を読み込めませんでした。",
        e);
    }
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    const latest = await this.getFixedPhrase(FixedPhraseKinds.AiUser, this.userId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.AiUser, this.userId, this.aiFixedPhraseOptions);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.AiUser, result);
  }
}
